import { Component, Inject, Input, OnInit, ChangeDetectorRef, ViewChild, EventEmitter, Output, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { BehaviorSubject, combineLatest, NEVER, Observable } from 'rxjs';
import { catchError, map, startWith, switchMap, tap } from 'rxjs/operators';
import { UntypedFormControl } from '@angular/forms';
import { APP_BASE_HREF } from '@angular/common';
import { GraphQLComparision } from '../../enums/GraphQLComparision.enum';
import { GraphQLConnector, GraphQLFilter, IGraphQlService } from '../../services/GraphQl/IGraphQL.service';

export interface DialogData {
  wheres: GraphQLFilter[];
  header: string;
  selectedEveUsers: any[]
}



/**
 * @title Injecting data when opening a dialog
 */
@Component({
  selector: 'user-pop-up.component',
  templateUrl: 'user-pop-up.component.html',
  styleUrls: ['./user-pop-up.component.css']
})
export class UserPopUpComponent implements AfterViewInit {


  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  searchControl = new UntypedFormControl('');


  eveUsersPageObservable: Observable<any>;
  totalCount: number = 0;


  selectedEveUsers: BehaviorSubject<any[]> = new  BehaviorSubject<any[]>([]);




  constructor(
    public dialogRef: MatDialogRef<UserPopUpComponent>,
    @Inject("BASE_REPORTING") public reportingUrl: string,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public graphQlService: IGraphQlService
  ) {

    this.selectedEveUsers.next(data.selectedEveUsers ?? [])
  }

  ngOnInit() {
    //const query = Object.assign({}, this.query, {});
    //
    //this.userArray = this.graphQlService.getGraphQlResults(query);
    //alert(this.userArray);

  }

  ngAfterViewInit(): void {
    this.searchControl.valueChanges.subscribe(() => this.paginator.pageIndex = 0);

    this.eveUsersPageObservable = combineLatest(
      combineLatest(this.paginator?.page.pipe(startWith(0)), this.searchControl.valueChanges.pipe(startWith(''))).pipe(
        switchMap(([page, search]) => {
          return this.graphQlService.getGraphQlResults({
            dataset: "eveUsersPage",
            selects: [
              {
                field: "eveUserId",
                arguments: null
              },
              {
                field: "eveUserName",
                arguments: null
              },
              {
                field: "firstName",
                arguments: null
              },
              {
                field: "surname",
                arguments: null
              },
              {
                field: "avatarImageId",
                arguments: null
              }
            ],
            wheres: [
              { path: "eveUserName", comparison: GraphQLComparision.CONTAINS, value: search, connector: GraphQLConnector.OR } as GraphQLFilter,
              { path: "firstName", comparison: GraphQLComparision.CONTAINS, value: search, connector: GraphQLConnector.OR } as GraphQLFilter,
              { path: "surname", comparison: GraphQLComparision.CONTAINS, value: search, connector: GraphQLConnector.OR } as GraphQLFilter,
            ].concat(this.data.wheres ?? []),
            groupBys: [],
            orderBy: [{ path: "firstName", descending: false }, { path: "surname", descending: false }],
            page: this.paginator.pageIndex,
            pageSize: this.paginator.pageSize
          })
        }),
        map(r => {
          return r.data.eveUsersPage;
        }),
        tap(eveUsersPage => this.totalCount = eveUsersPage.totalCount),
        catchError(val => {
          
          return NEVER;
        })
      ),
      this.selectedEveUsers
    ).pipe(
      map(([eveUsersPage, selectedEveUsers]) => {
        const items = eveUsersPage.items.map(e => Object.assign(e, { selected: selectedEveUsers.find(s => s.eveUserId == e.eveUserId) != null }));
        return Object.assign({}, eveUsersPage, { items: items });
      })
    );
  }



  public onSelectEveUser(eveUser) {
    

    const index = this.selectedEveUsers.value.findIndex(s => s.eveUserId == eveUser.eveUserId);

    if (index == -1) this.selectedEveUsers.next(this.selectedEveUsers.value.concat([eveUser]));
    else {
      this.selectedEveUsers.value.splice(index, 1)
      this.selectedEveUsers.next(this.selectedEveUsers.value);
    }
  }


  clearSelectedEveUsers() {
    this.selectedEveUsers.next([]);
  }

  applyChanges() {
    this.dialogRef?.close(this.selectedEveUsers.value);
  }

}


